package shaders

const val fs = """
    precision highp float;
        varying vec4 vertex_color;
        
        void main() {
          gl_FragColor = vertex_color;
        } 
"""